import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
export function EditCoupon() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;
  return <div className="space-y-4" data-id="element-445">
      <div className="flex items-center justify-between" data-id="element-446">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-447">
          {isEdit ? 'Edit Coupon' : 'Add Coupon'}
        </h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/coupons')} data-id="element-448">
          ← Back to Coupons
        </Button>
      </div>

      <Card data-id="element-449">
        <CardContent className="pt-6" data-id="element-450">
          <form className="space-y-4 max-w-md" data-id="element-451">
            <div data-id="element-452">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-453">
                Coupon Code
              </label>
              <input type="text" defaultValue={isEdit ? 'AN270' : ''} className="h-8 w-full rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-454" />
            </div>
            <div data-id="element-455">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-456">
                Discount Type
              </label>
              <select defaultValue={isEdit ? 'Percentage' : 'Dollar Amount'} className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-full" data-id="element-457">
                <option data-id="element-458">Dollar Amount</option>
                <option data-id="element-459">Percentage</option>
              </select>
            </div>
            <div data-id="element-460">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-461">
                Usage Type
              </label>
              <select defaultValue={isEdit ? 'Unlimited by Customer' : 'Per Customer'} className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-full" data-id="element-462">
                <option data-id="element-463">Per Customer</option>
                <option data-id="element-464">General Use</option>
                <option data-id="element-465">Unlimited</option>
                <option data-id="element-466">Unlimited by Customer</option>
              </select>
            </div>
            <div data-id="element-467">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-468">
                Group
              </label>
              <select defaultValue="PAR" className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-full" data-id="element-469">
                <option data-id="element-470">PAR</option>
                <option data-id="element-471">SAAR</option>
              </select>
            </div>
            <div data-id="element-472">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-473">
                Discount Amount
              </label>
              <input type="text" defaultValue={isEdit ? '100.00' : ''} className="h-8 w-32 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-474" />
            </div>
            <div data-id="element-475">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-476">
                Uses
              </label>
              <input type="text" defaultValue={isEdit ? '0' : ''} className="h-8 w-24 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-477" />
            </div>
            <div data-id="element-478">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-479">
                Expire Date
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-full" data-id="element-480">
                <option data-id="element-481">Not Set</option>
                <option data-id="element-482">Set</option>
              </select>
            </div>
            <div data-id="element-483">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-484">
                Limitations
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-full" data-id="element-485">
                <option data-id="element-486">All Courses/Packages</option>
                <option data-id="element-487">Only Single Course</option>
                <option data-id="element-488">Specific Course</option>
                <option data-id="element-489">Specific Package</option>
              </select>
            </div>
            <div data-id="element-490">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-491">
                Exceed?
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-32" data-id="element-492">
                <option data-id="element-493">No</option>
                <option data-id="element-494">Yes</option>
              </select>
            </div>
            <div className="pt-2" data-id="element-495">
              <Button type="submit" data-id="element-496">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}